<template>
  <v-app :dark="dark">
    <toolbar @toggle="dark = !dark" />
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Toolbar from '@/components/Toolbar.vue';

export default {
  components: {
    Toolbar,
  },

  data() {
    return {
      dark: false,
    };
  },
};
</script>

<style>
#app {
  font-family: Ubuntu, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.display-1, .headline {
  font-family: Ubuntu, sans-serif !important;
}

.v-btn__content {
  font-weight: normal;
}
</style>
